import { render, staticRenderFns } from "./EscrevaPostagens.vue?vue&type=template&id=73d09646&scoped=true"
import script from "./EscrevaPostagens.vue?vue&type=script&lang=js"
export * from "./EscrevaPostagens.vue?vue&type=script&lang=js"
import style0 from "./EscrevaPostagens.vue?vue&type=style&index=0&id=73d09646&prod&lang=scss&scoped=true"
import style1 from "./EscrevaPostagens.vue?vue&type=style&index=1&id=73d09646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d09646",
  null
  
)

export default component.exports